import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import TapnSection from "./components/TapnSection";
import DevelopersSection from "./components/DevelopersSection";
import TrustSection from "./components/TrustSection";
import ToolsSection from "./components/ToolsSection";
import UseCasesSection from "./components/UseCasesSection";
import CTASection from "./components/CTASection";
import TestimonialsSection from "./components/TestimonialsSection";
import Footer from "./components/Footer";
import { useSEO } from "../../hooks/useSEO";

export default function Home() {
  useSEO(
    "Paygent | Merchant Payments and Tapn Tap-to-Pay Solutions",
    "Paygent helps merchants get started with modern payment acceptance, gateway services, and Tapn tap-to-pay solutions for mobile-first commerce."
  );

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main id="main-content">
        <Hero />
        <TrustSection />
        <Features />
        <TapnSection />
        <DevelopersSection />
        <ToolsSection />
        <UseCasesSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
